const StaffExitFlowUnSelectedRadioButton = () => {
  return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="32"
        height="33"
        viewBox="0 0 32 33"
        fill="none"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M16 0.574219C7.175 0.574219 0 7.73952 0 16.5526C0 25.3657 7.175 32.531 16 32.531C24.825 32.531 32 25.3657 32 16.5526C32 7.73952 24.825 0.574219 16 0.574219Z"
          fill="#003399"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M23.7396 11.166C24.1271 11.553 24.1271 12.1896 23.7396 12.5766L14.3646 21.9389C14.1708 22.1324 13.9146 22.2323 13.6583 22.2323C13.4021 22.2323 13.1458 22.1324 12.9521 21.9389L8.26458 17.2578C7.87708 16.8708 7.87708 16.2341 8.26458 15.8472C8.65208 15.4602 9.28958 15.4602 9.67708 15.8472L13.6583 19.823L22.3271 11.166C22.7146 10.7728 23.3521 10.7728 23.7396 11.166Z"
          fill="white"
        />
      </svg>
  );
};
export default StaffExitFlowUnSelectedRadioButton;
